import React, { Component } from "react";
// reactstrap components
import {
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  Row,
  Col,
  Button,
} from "reactstrap";
import {
  Link
} from "react-router-dom";

import ReactTable from "react-table";
import ImageMappingService from '../../services/api/MachineImages'; 
import ScaleLoader from "react-spinners/ScaleLoader";
import LoadingOverlay from 'react-loading-overlay';
import { confirmAlert } from 'react-confirm-alert';
import { toast } from 'react-toastify';
import PanelHeader from "components/PanelHeader/PanelHeader.jsx";
import Pagination from "../../assets/js/Pagination";
import { cloudTypeLogo } from "settings/shared/commonMethod";
import { Scrollbars } from 'react-custom-scrollbars';

class imagemapping extends Component {
  constructor(props) {
    super(props);
    this.state = {
      columns:[],
      cloudimagesDTOS:[],
      cloudimagesdetails:[],
    swidth: window.innerWidth,
    sheight: window.innerHeight
    }
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);

    this.state.columns = [
      {
      Header: 'Id',
      accessor: 'Id',
      sortable: true,
      show: false
    }, 
    {
    Header: 'Name',
    accessor: 'Name',
    maxWidth: 200,
    sortable: true,
     }, 
    {
    Header: 'Cloud Type',
    accessor: 'CloudType',
    maxWidth: 200,
  },
  {
    Header: 'Image Type',
    accessor: 'ImageType',
    maxWidth: 200,
  },
  {
    Header: 'Architecture',
    accessor: 'Architecture',
    maxWidth: 200,
  },
  {
    Header: 'Region Name',
    accessor: 'RegionName',
    maxWidth: 200,
  },
  {
    Header: 'Zone Name',
    accessor: 'ZoneName',
    maxWidth: 200,
  },
  {
    Header: 'Image Id',
    accessor: 'ImageId',
    maxWidth: 200,
  },
  
  {
    Header: 'Actions',
    accessor: 'Actions',
    maxWidth: 135,

  }

];
  }
  componentDidMount() {
    this.GetAllCloudImages();
    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
  }
  
  updateWindowDimensions() {
    this.setState({ swidth: window.innerWidth, sheight: window.innerHeight});
  }

  EditImageMapping = (data) =>{
    this.props.history.push({
      pathname: '/cloud/newimagemapping',
      state: { EditData: data,mode:"editImageMapping" }
    })
  }

  DeleteImageMappingConfirm = (id,name) =>{
    confirmAlert({
      title: 'Remove Cloud Image',
      message: 'Are you sure to remove this Cloud Image -' + name + '?',
      buttons: [
        {
          label: 'Yes',
          onClick: e => this.DeleteImageMapping(id)
        },
        {
          label: 'No',
          onClick: () => console.log('')
        }
      ]
    });
  }
   DeleteImageMapping = (id) =>{
  if(id !== ""){
    ImageMappingService.DeleteCloudImage(id).then((response) => {
    if (response.status === 'SUCCESS') {
      // toast.success("Cloud Image Deleted Successfully!");
      toast.success(<i className="fas fa-check-circle">&nbsp; <b className="toast-txt">Cloud Image Deleted Successfully!</b></i>); 

      this.GetAllCloudImages();
    } else {
      toast.error(<i className="fas fa-times-circle">&nbsp; <b className="toast-txt">{response.errorMessage}</b></i>); 
    }
   }); 

}

}
  GetAllCloudImages = () =>{
  this.setState({
    loading:true
  })
    ImageMappingService.getAllCloudImages()
  .then((response) => {
    if (response.status === 'SUCCESS') {
      let cloudimagesData = response.cloudImagesDTOPage.content;
      this.renderData(cloudimagesData); 
      this.setState({
        cloudimagesDTOS:cloudimagesData,
        loading: false,
      });
      } else {
      this.setState({ loading: false}); 
      toast.error(<i className="fas fa-times-circle">&nbsp; <b className="toast-txt">{response.errorMessage}</b></i>); 
    }
  }).catch((error) => {
    this.setState({ loading:false });
  })

  
 }


 renderData(cloudimagesdetails){
  let datas = []; 
  cloudimagesdetails.map((item, index) => {
   datas.push({
     Id: item.id, 
     Name: <div className="namedisplay"> <span title={item.name} className="overflowStyle">{item.name}</span></div>,
     ImageType:<div className="namedisplay">{item.imageType}</div>,
     Architecture:<div className="namedisplay">{item.architecture}</div>,
     Description:<div className="namedisplay"><span title={item.description} className="overflowStyle">{item.description} </span></div>,
     CloudType:<div> {<p><img src={cloudTypeLogo(item.cloudType)} style={{ width: '25px', height: '25px' }}></img> </p>
    }</div> ,
     RegionName:<div className="namedisplay">{item.region}</div>,
     ZoneName:<div className="namedisplay">{item.zone}</div>,
     ImageId:<div className="namedisplay">{item.imageId}</div>,
    Actions:<div><i style={{cursor:"pointer"}} onClick={e=>this.EditImageMapping(item)} className="fa fa-edit text-info"/>
     <i style={{cursor:"pointer", marginLeft:10,color:"red"}} onClick={e=>this.DeleteImageMappingConfirm(item.id,item.name)} className="fas fa-trash-alt text-red mr-2"/></div>,
     })
  });

   this.setState({
      cloudimagesdetails:datas,
   });

}
 

  
  render() {
    return (
  
      <>
        <PanelHeader
          content={
            <div className="header text-center">
            
            </div>
          }
        />
        <div className="content">
        <LoadingOverlay
      active={this.state.loading}
      spinner={<ScaleLoader
        height={35}
        width={5}
        radius={2}
        margin={2}
        color={"#123abc"}
        loading={this.state.loading}
      />}
    >
          <Row>
            <Col xs={12} md={12}>
            <Row>
            <div className=" col">
              <Card>
                <CardHeader>
                <Row className="align-items-center">
                <div className="col">
                  <CardTitle tag="h5">Image Mapping</CardTitle>
                 </div>
                 <div className="col text-right">
                      <span> <i style={{cursor:"pointer"}} className="fas fa-sync-alt mr-3" onClick={e =>this.GetAllCloudImages()}/></span>
                       <Link to={{ 
                        pathname: '/cloud/newimagemapping',
                        state: { mode:"addnew" }
                      }}> 
                         <Button
                        color="primary"
                        href=""
                        size="sm"
                      >
                      Create
                      </Button>
                      </Link>
                    </div>
                </Row>
                  
                </CardHeader>
                <CardBody >
                <div className="carcontent">
                <Scrollbars autoHeight autoHeightMin={this.state.sheight-220}>
                <ReactTable
         data={ this.state.cloudimagesdetails}
         columns={ this.state.columns }
         defaultPageSize={10}
         PaginationComponent={Pagination}
         showPaginationBottom={true}
         className="-striped -highlight Providerstable"
          />
                       </Scrollbars>

          </div>
              </CardBody>
              </Card>
           </div>
           </Row>

            </Col>
          </Row>
          </LoadingOverlay>

        </div>
      </>
    );
  }
}

export default imagemapping;

